'use client';

import type { SpacerBlock } from '@impact/types';
import { cn } from '@/lib/utils';

interface SpacerBlockRendererProps {
  block: SpacerBlock;
  editing?: boolean;
}

const HEIGHT_CLASSES = {
  sm: 'h-8',
  md: 'h-16',
  lg: 'h-24',
  xl: 'h-32',
} as const;

const HEIGHT_LABELS = {
  sm: 'Small · 32px',
  md: 'Medium · 64px',
  lg: 'Large · 96px',
  xl: 'Extra large · 128px',
} as const;

export function SpacerBlockRenderer({ block, editing }: SpacerBlockRendererProps) {
  const { height = 'md' } = block.data;

  if (!editing) {
    return <div className={cn(HEIGHT_CLASSES[height])} />;
  }

  return (
    <div
      className={cn(
        'group relative flex w-full items-center justify-center transition-colors',
        HEIGHT_CLASSES[height],
        'border border-dashed border-transparent hover:border-muted-foreground/40 hover:bg-muted/20',
      )}
    >
      <span className="pointer-events-none rounded-md bg-background px-2 py-0.5 text-xs font-medium text-muted-foreground opacity-0 shadow-sm transition-opacity group-hover:opacity-100">
        {HEIGHT_LABELS[height]}
      </span>
    </div>
  );
}
